import React from 'react';
import heroImage from '../img/hero/hero_asv.png';
import '../pages/Home.css';

function Hero() {
  return (
    <section className="site-hero site-hero--fullwidth">
      <div className="container-fluid px-0">
        <div className="hero-top-text text-center">
          <h1 className="hero-title">
            Play and learn in the<br />
            <span className="hero-title-accent">Natural World.</span>
          </h1>
          <p className="hero-sub">
            BioEra™, a card game designed for curious minds. Build a thriving ecosystem. Hunt other player's lifeforms. Hours of fun with game mechanics inspired in the wonders of our natural world.
          </p>
        </div>
        <img src={heroImage} alt="BioEra — A card game about the Natural World" className="hero-image-fullwidth" />
      </div>
    </section>
  );
}

export default Hero;
